export enum NotificationPermission {
    yes,
    no,
    unknown
}
